import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const CalendarColoredIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0  120 120" style={{ color, fontSize, ...style }} {...rest}>
      <g>
        <path
          style={{ fill: '#FFFFFF' }}
          d="M23.4,100.7h73.1c4.1,0,7.3-3.3,7.3-7.3V31.1c0-4.1-3.3-7.3-7.3-7.3H23.4c-4.1,0-7.3,3.3-7.3,7.3v62.2   C16.1,97.4,19.4,100.7,23.4,100.7z"
        />
        <path
          style={{ fill: '#F47C7C' }}
          d="M103.9,30.8v15.1H16.1V30.8c0-3.9,3.2-7,7-7h73.7C100.7,23.7,103.9,26.9,103.9,30.8z"
        />
        <g>
          <circle style={{ fill: '#D66767' }} cx="38.9" cy="34.8" r="3.6" />
          <circle style={{ fill: '#D66767' }} cx="60" cy="34.8" r="3.6" />
          <circle style={{ fill: '#D66767' }} cx="81.1" cy="34.8" r="3.6" />
        </g>
        <g>
          <path
            style={{ fill: '#FFF2F2' }}
            d="M39.9,19.3h-2c-0.6,0-1.1,0.5-1.1,1.1v13.9c0,0.6,0.5,1.1,1.1,1.1h2c0.6,0,1.1-0.5,1.1-1.1V20.5    C41.1,19.8,40.5,19.3,39.9,19.3z"
          />
          <path
            style={{ fill: '#FFF2F2' }}
            d="M61,19.3h-2c-0.6,0-1.1,0.5-1.1,1.1v13.9c0,0.6,0.5,1.1,1.1,1.1h2c0.6,0,1.1-0.5,1.1-1.1V20.5    C62.1,19.8,61.6,19.3,61,19.3z"
          />
          <path
            style={{ fill: '#FFF2F2' }}
            d="M82.1,19.3h-2c-0.6,0-1.1,0.5-1.1,1.1v13.9c0,0.6,0.5,1.1,1.1,1.1h2c0.6,0,1.1-0.5,1.1-1.1V20.5    C83.2,19.8,82.7,19.3,82.1,19.3z"
          />
        </g>
        <g>
          <path
            style={{ fill: '#87A9FF' }}
            d="M40.9,56h-8.6c-1,0-1.8,0.8-1.8,1.8v8.6c0,1,0.8,1.8,1.8,1.8h8.6c1,0,1.8-0.8,1.8-1.8v-8.6    C42.8,56.9,42,56,40.9,56z"
          />
          <path
            style={{ fill: '#87A9FF' }}
            d="M64.3,56h-8.6c-1,0-1.8,0.8-1.8,1.8v8.6c0,1,0.8,1.8,1.8,1.8h8.6c1,0,1.8-0.8,1.8-1.8v-8.6    C66.2,56.9,65.3,56,64.3,56z"
          />
          <path
            style={{ fill: '#87A9FF' }}
            d="M87.7,56h-8.6c-1,0-1.8,0.8-1.8,1.8v8.6c0,1,0.8,1.8,1.8,1.8h8.6c1,0,1.8-0.8,1.8-1.8v-8.6    C89.5,56.9,88.7,56,87.7,56z"
          />
          <path
            style={{ fill: '#87A9FF' }}
            d="M40.9,78.7h-8.6c-1,0-1.8,0.8-1.8,1.8v8.6c0,1,0.8,1.8,1.8,1.8h8.6c1,0,1.8-0.8,1.8-1.8v-8.6    C42.8,79.5,42,78.7,40.9,78.7z"
          />
          <path
            style={{ fill: '#87A9FF' }}
            d="M64.3,78.7h-8.6c-1,0-1.8,0.8-1.8,1.8v8.6c0,1,0.8,1.8,1.8,1.8h8.6c1,0,1.8-0.8,1.8-1.8v-8.6    C66.2,79.5,65.3,78.7,64.3,78.7z"
          />
          <path
            style={{ fill: '#87A9FF' }}
            d="M87.7,78.7h-8.6c-1,0-1.8,0.8-1.8,1.8v8.6c0,1,0.8,1.8,1.8,1.8h8.6c1,0,1.8-0.8,1.8-1.8v-8.6    C89.5,79.5,88.7,78.7,87.7,78.7z"
          />
        </g>
      </g>
    </SvgIcon>
  )
}
export default CalendarColoredIcon
